import { defineStore } from 'pinia';
import { getUserDetailFromkey, isUserAdmin } from 'src/utils/UserDetails';

interface AclRow {
  assigned_to_user_id?: string;
  assigned_to_group_id?: string;
}

export const useAclStore = defineStore('acl_store', {
  state: () => ({
    userGroupIds: [] as string[],
    isUserAdmin: isUserAdmin(),
    userId: getUserDetailFromkey('id'),
    list_size_key: 'TASK_PAGINATION_SIZE',
    permissionGroupReqPromise: null as Promise<void> | null,
  }),
  getters: {},
  actions: {
    async fetchPermissionGroup() {
      if (this.permissionGroupReqPromise) {
        return this.permissionGroupReqPromise;
      }

      this.permissionGroupReqPromise = new Promise<void>((resolve) => {
        resolve();
        this.loadUserAcls();
      });

      return this.permissionGroupReqPromise;
    },

    async getUserAclIds() {
      try {
        const { userApiService } = await import('src/services');
        const response = await userApiService.getUserAcls();
        this.userGroupIds = response.group_permissions.map(
          (group: { group_id: string }) => group.group_id,
        );
      } catch (error) {
        return error;
      }
    },

    isHasAccess(row: AclRow): boolean {
      return (
        this.isUserAdmin ||
        (row.assigned_to_user_id !== this.userId &&
          !this.userGroupIds.includes(row.assigned_to_group_id ?? ''))
      );
    },

    isGroupExists(id: string): boolean {
      return this.userGroupIds.includes(id);
    },
  },
});
